import { Navbar, Nav, Container, Button, Image } from 'react-bootstrap';
import { FaInstagram, FaFacebookF, FaTwitter, FaGoogle } from 'react-icons/fa';
import logo from '../assets/logo.png';
import 'bootstrap/dist/css/bootstrap.min.css';

const BarberNav = () => {
  return (
    <Navbar expand="lg" fixed="top" variant="dark" style={{ backgroundColor: 'rgba(0, 0, 0, .5)', fontSize: "1.2rem" }}>
      <Container>
        {/* Brand in center */}
        <Navbar.Brand href="#home" className="mx-auto d-lg-none">
          <Image src={logo} alt="Fort Worth Barber Shop Logo" height="80" />
        </Navbar.Brand>

        {/* Mobile toggle */}
        <Navbar.Toggle aria-controls="barber-navbar" />

        <Navbar.Collapse id="barber-navbar">
          {/* Left Links */}
          <Nav className="me-auto text-center text-lg-start">
            <Nav.Link href="#services">Serviços</Nav.Link>
            <Nav.Link href="#about">Sobre</Nav.Link>
            <Nav.Link href="#contact">Contato</Nav.Link>
            <Nav.Link href="#shop">Produtos</Nav.Link>
          </Nav>

          {/* Brand center (desktop only) */}
          <Navbar.Brand href="/" className="mx-auto d-none d-lg-block">
            <Image src={logo} alt="Barbearia Ávila logo" height="150" />
          </Navbar.Brand>

          {/* Right Social + Button */}
          <Nav className="ms-auto align-items-center justify-content-center mt-3 mt-lg-0 text-center">
            <Nav.Link href="https://www.instagram.com/barbeariaavila" target="_blank">
              <FaInstagram size={22} />
            </Nav.Link>
            <Nav.Link href="https://www.facebook.com/barbeariaavilapelotas" target="_blank">
              <FaFacebookF size={22} />
            </Nav.Link>
            <Nav.Link href="https://g.co/kgs/daUQV31" target="_blank">
              <FaGoogle size={22} />
            </Nav.Link>
            <Button 
               href="https://wa.me/555384339680"
              target="_blank"
              className="mt-3 mt-lg-0 ms-lg-3 text-dark text-uppercase fw-bold"
              style={{
                backgroundColor: '#b68e5d',
                border: 'none',
                height: '60px',
                paddingTop: '18px',
              }}
            >
              AGENDE SEU HORÁRIO!
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default BarberNav;
